import { useMemo } from "react";
import { Category } from "../constants/category";

export interface PostArgs {
  posts: readonly Queries.MarkdownRemarkEdge[];
  selectedCategory: string;
  selectedTags: string[];
  search: string;
}

export const usePosts = ({
  posts,
  selectedCategory,
  selectedTags,
  search,
}: PostArgs) => {
  const filteredPosts = useMemo(
    () =>
      posts.filter(({ node }) => {
        const tags = node.frontmatter?.tags?.filter(
          (tag: Queries.Maybe<string>) =>
            selectedTags.indexOf(tag as string) !== -1,
        );

        const searchInclude =
          node.frontmatter?.title
            ?.toLowerCase()
            .includes(search.toLowerCase()) ||
          node.frontmatter?.subtitle
            ?.toLowerCase()
            .includes(search.toLowerCase());

        const noTag = selectedTags.length === 0;

        return (
          (selectedCategory === Category.All &&
            (noTag || (tags && tags.length > 0)) &&
            searchInclude) ||
          (node.frontmatter?.category === selectedCategory &&
            searchInclude &&
            (noTag || (tags && tags?.length > 0)))
        );
      }),
    [selectedCategory, selectedTags, search],
  );

  return { filteredPosts };
};
